import axios from 'axios';
import i18n from '../i18n';
import { safeLocalStorage } from '../utils/storage';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add JWT token to requests
api.interceptors.request.use(
  (config) => {
    const token = safeLocalStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // ponytail: let Axios set the correct multipart boundary automatically if data is FormData
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data
      safeLocalStorage.removeItem('token');
      safeLocalStorage.removeItem('user');
      
      // Do not redirect or reload if already on the admin login page
      const isAlreadyOnLoginPage = window.location.pathname === '/admin/login';
      
      if (!isAlreadyOnLoginPage) {
        const isAdminRoute = window.location.pathname.startsWith('/admin');
        const hasToken = safeLocalStorage.getItem('token');
        
        // Only redirect if user was authenticated or on an admin page
        if (hasToken || isAdminRoute) {
          window.location.href = '/admin/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
